(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["text-columns-with-images"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Parallax effect for background image
    const bgImage = document.querySelector('.wide-section .section-bg-image');
    const section = document.querySelector('.wide-section');
    
    if (bgImage && section) {
      let ticking = false;
      
      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const scrolled = window.pageYOffset;
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
            const windowHeight = window.innerHeight;
            
            if (scrolled + windowHeight > sectionTop && scrolled < sectionTop + sectionHeight) {
              const relativeScroll = scrolled - sectionTop + windowHeight;
              const sectionViewport = sectionHeight + windowHeight;
              const scrollPercent = relativeScroll / sectionViewport;
              
              const yPos = (scrollPercent - 0.5) * 200;
              const clampedYPos = Math.max(-100, Math.min(100, yPos));
              
              bgImage.style.transform = `translateY(${clampedYPos}px)`;
            }
            
            ticking = false;
          });
          
          ticking = true;
        }
      }, { passive: true });
    }
    
    if (typeof Flickity !== 'undefined') {
      var sliders = document.querySelectorAll('.js-text-columns-slider');
      sliders.forEach(function(slider) {
        new Flickity(slider, {
          cellAlign: 'left',
          contain: false,
          freeScroll: true,
          wrapAround: true,
          prevNextButtons: true,
          pageDots: false,
          imagesLoaded: true,
          lazyLoad: 2
        });
      });
      console.log('Flickity sliders initialized');
    } else {
      console.error('Flickity library not loaded');
    }

    // FIXED: Get the store's base currency (now SAR)
    const STORE_BASE_CURRENCY = 'SAR';

    function getCurrentCurrency() {
      let currency = STORE_BASE_CURRENCY;
      
      if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
        currency = Shopify.currency.active;
      }
      
      const currencySpan = document.querySelector('.money .currency, [data-currency], .selected-currency');
      if (currencySpan) {
        const currencyText = currencySpan.textContent || currencySpan.getAttribute('data-currency');
        if (currencyText && currencyText.length === 3) {
          currency = currencyText.trim();
        }
      }
      
      const hiddenInput = document.querySelector('input[name="currency_code"], input[name="currency"], input[name="shopify-currency"]');
      if (hiddenInput && hiddenInput.value) {
        currency = hiddenInput.value;
      }
      
      const cookies = document.cookie.split(';').reduce((acc, cookie) => {
        const [key, value] = cookie.trim().split('=');
        acc[key] = value;
        return acc;
      }, {});
      if (cookies['cart_currency'] || cookies['currency']) {
        currency = cookies['cart_currency'] || cookies['currency'];
      }
      
      console.log('Current currency detected:', currency);
      return currency;
    }

    function fetchProductData(productHandle, callback) {
      fetch(`/products/${productHandle}.js`)
        .then(response => {
          if (!response.ok) throw new Error(`Failed to fetch /products/${productHandle}.js: ${response.status}`);
          return response.json();
        })
        .then(data => {
          const variants = data.variants.reduce((acc, variant) => {
            acc[variant.id] = {
              price: variant.price / 100,
              comparePrice: variant.compare_at_price ? variant.compare_at_price / 100 : null,
              title: variant.title.split(' / ').pop()
            };
            return acc;
          }, {});
          console.log(`Fetched product data for ${productHandle}:`, variants);
          callback(variants);
        })
        .catch(error => {
          console.error(`Error fetching product data for ${productHandle}:`, error);
        });
    }

    // FIXED: Convert from store base currency (SAR) to target currency
    function convertCurrency(priceInBase, targetCurrency) {
      // If target currency is same as store base, no conversion needed
      if (targetCurrency === STORE_BASE_CURRENCY) {
        return priceInBase;
      }
      
      // Use Shopify's Currency converter if available
      if (typeof Currency !== 'undefined' && Currency.convert) {
        return Currency.convert(priceInBase * 100, STORE_BASE_CURRENCY, targetCurrency) / 100;
      }
      
      // Fallback - return base price (no conversion)
      console.warn('Currency conversion not available, displaying in', STORE_BASE_CURRENCY);
      return priceInBase;
    }

    // FIXED: Format price with correct currency
    function formatPrice(priceInBase, targetCurrency) {
      const convertedPrice = convertCurrency(priceInBase, targetCurrency);
      
      console.log(`Formatting price: ${priceInBase} ${STORE_BASE_CURRENCY} -> ${convertedPrice} ${targetCurrency}`);
      
      try {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          const formatted = Shopify.formatMoney(convertedPrice * 100, '{{ shop.money_format }}');
          // Replace any currency code with the target currency
          return formatted.replace(/KWD|USD|SAR|AED|EUR|GBP/g, targetCurrency);
        }
      } catch (e) {
        console.error('Error in Shopify.formatMoney:', e);
      }
      
      // Fallback formatting
      if (targetCurrency === 'SAR' || targetCurrency === 'AED') {
        return convertedPrice.toFixed(2) + ' ' + targetCurrency;
      } else if (targetCurrency === 'KWD') {
        return convertedPrice.toFixed(3) + ' ' + targetCurrency;
      }
      return convertedPrice.toFixed(2) + ' ' + targetCurrency;
    }

    function updateProductPrices(productId, productHandle, selectElement) {
      const select = selectElement || document.querySelector(`.size-select[data-product-id="${productId}"]`);
      const priceWrapper = document.querySelector(`.price-display-wrapper[data-product-id="${productId}"]`);
      const priceDisplaySale = document.querySelector(`.product-price-sale[data-product-id="${productId}"]`);
      const priceDisplayOriginal = document.querySelector(`.product-price-original[data-product-id="${productId}"]`);
      const savingsText = document.querySelector(`.savings-text[data-product-id="${productId}"]`);
      const buttonsContainer = document.querySelector(`.product-buttons[data-product-id="${productId}"]`);
      const currentCurrency = getCurrentCurrency();
      
      console.log(`Updating prices for product ${productId} (handle: ${productHandle}) in ${currentCurrency}`);

      if (!select || !productHandle) {
        console.error(`Invalid select or productHandle for product ${productId}`);
        return;
      }

      fetchProductData(productHandle, (variants) => {
        const variantId = select.value;
        
        if (!variantId) {
          if (priceWrapper) priceWrapper.style.display = 'none';
          return;
        }

        const variantData = variants[variantId];
        
        if (!variantData) {
          console.error(`Variant ${variantId} not found`);
          return;
        }

        // Prices from API are already in store base currency (SAR)
        const price = variantData.price;
        const comparePrice = variantData.comparePrice;

        if (priceWrapper) priceWrapper.style.display = 'block';
        
        if (priceDisplaySale) {
          priceDisplaySale.textContent = formatPrice(price, currentCurrency);
        }

        if (comparePrice && comparePrice > price) {
          if (priceDisplayOriginal) {
            priceDisplayOriginal.textContent = formatPrice(comparePrice, currentCurrency);
            priceDisplayOriginal.style.display = 'inline';
          }
          
          if (savingsText) {
            const savingsAmount = comparePrice - price;
            const savingsPercent = Math.round((savingsAmount / comparePrice) * 100);
            savingsText.textContent = `You save ${savingsPercent}% (${formatPrice(savingsAmount, currentCurrency)})`;
            savingsText.style.display = 'block';
          }
        } else {
          if (priceDisplayOriginal) priceDisplayOriginal.style.display = 'none';
          if (savingsText) savingsText.style.display = 'none';
        }
      });
    }

    document.querySelectorAll('.glass-button.size-select').forEach(select => {
      select.addEventListener('change', function(e) {
        const variantId = this.value;
        const productId = this.getAttribute('data-product-id');
        const productHandle = this.getAttribute('data-product-handle');
        const sliderItem = this.closest('.slider-item');
        const buyNowButton = sliderItem ? sliderItem.querySelector('.buy-now') : null;

        if (variantId && buyNowButton) {
          buyNowButton.setAttribute('data-variant-id', variantId);
          updateProductPrices(productId, productHandle, this);
        }
      });
    });

    document.querySelectorAll('.buy-now').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const productId = this.getAttribute('data-product-id');
        const select = document.querySelector(`.size-select[data-product-id="${productId}"]`);
        
        if (!select || !select.value || select.value === '') {
          if (select) {
            select.scrollIntoView({ behavior: 'smooth', block: 'center' });
            select.style.borderColor = '#ff6b6b';
            select.style.boxShadow = '0 0 15px rgba(255, 107, 107, 0.5)';
            
            setTimeout(() => {
              select.style.borderColor = '';
              select.style.boxShadow = '';
            }, 3000);
          }
          
          return;
        }
        
        const variantId = select.value;
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          window.location.href = '/cart';
        })
        .catch(error => {
          console.error('Error adding product to cart:', error);
          alert('Failed to add product to cart. Please try again.');
        });
      });
    });

    const selectors = [
      '#currency-selector',
      'select[name="currency"]',
      '.currency-selector',
      '#CurrencySelector',
      '.bcc-currency-selector',
      'select[name="currency_code"]',
      '.currency-switcher'
    ];
    const currencySelector = document.querySelector(selectors.join(', '));
    if (currencySelector) {
      currencySelector.addEventListener('change', function() {
        setTimeout(() => {
          document.querySelectorAll('.size-select').forEach(select => {
            const productId = select.getAttribute('data-product-id');
            const productHandle = select.getAttribute('data-product-handle');
            if (select.value) {
              updateProductPrices(productId, productHandle, select);
            }
          });
        }, 300);
      });
    }

    document.addEventListener('currencyChanged', function() {
      document.querySelectorAll('.size-select').forEach(select => {
        const productId = select.getAttribute('data-product-id');
        const productHandle = select.getAttribute('data-product-handle');
        if (select.value) {
          updateProductPrices(productId, productHandle, select);
        }
      });
    });

    let lastCurrency = getCurrentCurrency();
    setInterval(() => {
      const currentCurrency = getCurrentCurrency();
      if (currentCurrency !== lastCurrency) {
        document.querySelectorAll('.size-select').forEach(select => {
          const productId = select.getAttribute('data-product-id');
          const productHandle = select.getAttribute('data-product-handle');
          if (select.value) {
            updateProductPrices(productId, productHandle, select);
          }
        });
        lastCurrency = currentCurrency;
      }
    }, 500);
  });

  } catch(e) { console.error(e); }
})();
})();
